// ======================================================================
// File Name       : EmailRegisterEditUserContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col } from 'react-bootstrap';
import { change, getFormValues } from 'redux-form';
import * as emailActions from '../../actions/EmailAction';
import SelectGroupDlg from '../../components/course/SelectGroupDialog';
import EmailEditUser from '../../components/email/EmailEditUser';
import EmailEditUserSearchForm from '../../components/email/EmailEditUserSearchForm';
import EmailEditUserSearchList from '../../components/email/EmailEditUserSearchList';
import MessageSearch from '../../components/MessageSearch';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { RETURN_MAX_NUM, RETURN_MAX_NUM_1000 } from '../../constants';
import { hideLoading, showLoading } from '../../utils/PageUtils';

class EmailRegisterEditUserContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedUser: [],
      checkedUserOnPage: [],
      showSelectGroup: false,
      isAllowShowSearchMessage: false,
      isInit: true,
      selectedGroup: [],
      startPosition: 0,
    };

    this.handleCancelBtn = this.handleCancelBtn.bind(this);
    this.handleOkBtn = this.handleOkBtn.bind(this);
    this.handleSearchUserConditionChange = this.handleSearchUserConditionChange.bind(this);
    this.handleUserCheck = this.handleUserCheck.bind(this);
    this.handleAddRemoveAllUser = this.handleAddRemoveAllUser.bind(this);
    this.handleAddSelectedUser = this.handleAddSelectedUser.bind(this);
    this.handleRemoveUser = this.handleRemoveUser.bind(this);
    this.handleRemoveAllUser = this.handleRemoveAllUser.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.cancelSelectGroupDlg = this.cancelSelectGroupDlg.bind(this);
    this.showSelectGroupDlg = this.showSelectGroupDlg.bind(this);
    this.okSelectGroupDlg = this.okSelectGroupDlg.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.createParams = this.createParams.bind(this);
    this.removeGroup = this.removeGroup.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(emailActions.resetSearchUserCondition());
    this.handleSearchBtn();
    // Save init state
    this.props.dispatch(emailActions.backupInitState());
  }

  componentWillUnmount() {
    this.props.dispatch(emailActions.resetSearchUserCondition());
  }

  handleSearchBtn() {
    const { dispatch, email, formValues } = this.props;
    const { checkedUser, editingUser } = email;
    const groupSecernIds = email.selectedGroupList.reduce((acc, cur) => {
      if (cur.groupSecernId) {
        acc.push(cur.groupSecernId);
        return acc;
      }
    }, []);
    this.createParams(formValues) && (email.searchUserCondition = this.createParams(formValues));
    dispatch(emailActions.resetSearchUserData());

    if (checkedUser && editingUser) {
      checkedUser.allSecernIds = checkedUser.allSecernIds.reduce((acc, cur, index) => {
        if (checkedUser.bySecernId[cur] && !editingUser[cur]) {
          delete checkedUser.bySecernId[cur];
        } else {
          acc.push(cur);
        }
        return acc;
      }, []);
    }
    this.setState(
      {
        isAllowShowSearchMessage: false,
      },
      () => {
        dispatch(
          emailActions.searchUser({
            ...email.searchUserCondition,
            startPosition: 0,
            returnMaxNum: RETURN_MAX_NUM,
            selectedGroupList: groupSecernIds,
          }),
        ).then(() => {
          if (!this.state.isInit) {
            this.setState({ isAllowShowSearchMessage: true });
          }
        });
      },
    );
  }

  createParams(formValues) {
    const { email } = this.props;
    const param = {};
    if (formValues) {
      formValues.userName && (param.userName = formValues.userName);
      formValues.loginId && (param.loginId = formValues.loginId);
      formValues.userAttributeKeyNum && (param.userAttributeKeyNum = formValues.userAttributeKeyNum);
      formValues.userAttributeSearchText && (param.userAttributeSearchText = formValues.userAttributeSearchText);
      formValues.dormantState && (param.dormantState = formValues.dormantState);
      if (email && email.selectedGroupList) {
        param.selectedGroupList = email.selectedGroupList;
      }
    }
    return param;
  }

  handleCancelBtn() {
    const { dispatch } = this.props;
    // Restore init state
    dispatch(emailActions.restoreInitState());
    this.props.hideModal();
  }

  handleOkBtn() {
    const { dispatch, email } = this.props;
    this.props.hideModal();
    dispatch(change('emailRegisterEditForm', 'emailReceiverList', email.editingUser));
  }

  handleSearchUserConditionChange({ target }) {
    const { dispatch } = this.props;
    const { name, value } = target;
    dispatch(emailActions.editingUserSearchCondition({ [name]: value }));
  }

  handleUserCheck(event) {
    const userSecernId = event.target.value;
    const { dispatch } = this.props;
    dispatch(emailActions.addRemoveUser(userSecernId));
  }

  async handleAddRemoveAllUser() {
    const { dispatch, email, formValues } = this.props;
    const groupSecernIds = email.selectedGroupList.reduce((acc, cur) => {
      if (cur.groupSecernId) {
        acc.push(cur.groupSecernId);
        return acc;
      }
    }, []);

    dispatch(showLoading());
    this.createParams(formValues) && (email.searchUserCondition = this.createParams(formValues));

    const position = 0;
    dispatch(emailActions.resetSearchUserData());

    await dispatch(emailActions.getAllUser({
      ...email.searchUserCondition,
      startPosition: position,
      returnMaxNum: RETURN_MAX_NUM_1000,
      selectedGroupList: groupSecernIds,
    }))
    .then(() => {
      dispatch(emailActions.checkAllUser());
      dispatch(hideLoading());
    });
  }

  handleAddSelectedUser() {
    const { dispatch } = this.props;
    dispatch(emailActions.addSelectedUser());
    this.scrollToBottom();
  }

  handleRemoveUser(userSecernId) {
    const { dispatch } = this.props;
    dispatch(emailActions.removeUser(userSecernId));
  }

  handleRemoveAllUser() {
    this.props.dispatch(emailActions.removeAllUser());
  }

  handlePageChange(startPosition) {
    const { dispatch, email } = this.props;
    const groupSecernIds = email.selectedGroupList.reduce((acc, cur) => {
      if (cur.groupSecernId) {
        acc.push(cur.groupSecernId);
        return acc;
      }
    }, []);

    dispatch(
      emailActions.searchUser({
        ...email.searchUserCondition,
        startPosition,
        returnMaxNum: RETURN_MAX_NUM,
        selectedGroupList: groupSecernIds,
      }),
    );

    this.setState({ selectedPosition: startPosition });
  }

  scrollToBottom() {
    const node = document.getElementById('scroll-table-email');
    node.scrollIntoView({ behavior: 'smooth' });
  }

  getModalOptions() {
    return {
      title: 'メール送信先ユーザーを指定してください',
      footerBtns: null,
      dialogClassName: 'email-edit-user-dialog',
    };
  }

  /**
   * Show select group dialog
   */
  showSelectGroupDlg() {
    this.setState({ showSelectGroup: true });
  }

  /**
   * Handle event when click on キャンセル of select group dialog
   */
  cancelSelectGroupDlg() {
    this.setState({ showSelectGroup: false });
  }

  /**
   * Handle event when click on OK of select group dialog
   *
   * @param {object} group
   */
  okSelectGroupDlg(group) {
    const { dispatch } = this.props;
    this.setState({
      showSelectGroup: false,
    },
      () => {
        dispatch(emailActions.addGroup(group));
      },
    );
  }

  /**
   * Handle event when click on trash icon
   * @param {*} groupSecernId
   */
  removeGroup(groupSecernId) {
    const { dispatch } = this.props;
    dispatch(emailActions.removeGroup(groupSecernId));
  }

  render() {
    const { authority, email, groupList } = this.props;
    const {
      searchUserResult,
      editingUser,
      checkedUser,
      selectedGroupList,
    } = email;

    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.handleCancelBtn}
      >
        <div>
          <MessageSearch
            recordNum={searchUserResult ? searchUserResult.recordNum : 0}
            resultList={searchUserResult ? searchUserResult.allSecernIds : []}
            isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
            dismissMessage={this.props.dismissMessage}
          />
          <EmailEditUserSearchForm
            handleSearchBtn={this.handleSearchBtn}
            showSelectGroupDlg={this.showSelectGroupDlg}
            removeGroup={this.removeGroup}
            groupList={groupList}
            selectedGroupList={selectedGroupList}
          />

          <EmailEditUserSearchList
            searchUserResult={searchUserResult}
            checkedUser={checkedUser}
            editingUser={editingUser}
            authority={authority}
            handlePageChange={this.handlePageChange}
            handleUserCheck={this.handleUserCheck}
            handleAddSelectedUser={this.handleAddSelectedUser}
            handleRemoveAllUser={this.handleRemoveAllUser}
            handlePeriodTimeChange={this.handlePeriodTimeChange}
            handleRemoveUser={this.handleRemoveUser}
            handleAddRemoveAllUser={this.handleAddRemoveAllUser}
          />
          <EmailEditUser
            editingUser={editingUser}
            authority={authority}
            handleRemoveAllUser={this.handleRemoveAllUser}
            handlePeriodTimeChange={this.handlePeriodTimeChange}
            handleRemoveUser={this.handleRemoveUser}
          />
          <SelectGroupDlg
            showModal={this.state.showSelectGroup}
            selectedGroupList={selectedGroupList}
            selectedGroup={selectedGroupList}
            groupList={groupList}
            onCancel={this.cancelSelectGroupDlg}
            onOK={this.okSelectGroupDlg}
            isCheckBox
          />
        </div>
        <Col sm={12} className="text-center padding-top-10">
          <Button
            style={{ marginRight: '5px' }}
            onClick={this.handleCancelBtn}
            className="btn-96"
            variant="default"
          >
            {'キャンセル'}
          </Button>
          <Button variant="primary" className="btn-96" onClick={this.handleOkBtn}>
            {'OK'}
          </Button>
        </Col>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { authority, user, email, authed, group } = state;
  const { groupList } = group;
  const { authedUser } = authed;
  const { userInfo } = authedUser;
  const formValues = getFormValues('emailEditUserSearchForm')(state);
  return {
    email,
    groupList,
    authority: authority.authorityInfo,
    userInfo,
    user,
    formValues,
  };
};

export default connect(mapStateToProps)(EmailRegisterEditUserContainer);
